import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#0F172A] mb-4">About EquiCore Nexus</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-[#3B82F6] to-emerald-500 mx-auto rounded-full"></div>
          <p className="text-xl text-gray-600 mt-6 max-w-3xl mx-auto">
            We bridge the gap between innovative companies and strategic capital.
          </p>
        </div>
        
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="lg:w-1/2 relative">
            <div className="relative rounded-xl overflow-hidden shadow-xl">
              <img 
                src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
                alt="Financial Strategy Meeting" 
                className="w-full h-auto rounded-xl" 
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/80 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-6 text-white">
                <h3 className="text-xl font-semibold">Strategic Financial Planning</h3>
                <p className="text-sm opacity-90">Tailored solutions for each growth stage</p>
              </div>
            </div>
            
            <div className="absolute -top-6 -right-6 bg-white p-6 rounded-xl shadow-lg w-3/4 z-10 hidden md:block">
              <div className="flex items-start">
                <div className="bg-[#3B82F6]/10 p-3 rounded-lg mr-4">
                  <i className="fas fa-lightbulb text-[#3B82F6] text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#0F172A] mb-2">Our Vision</h4>
                  <p className="text-sm text-gray-600">To be the most trusted financial partner for high-growth companies worldwide.</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="lg:w-1/2">
            <h3 className="text-2xl font-semibold text-[#0F172A] mb-6">Strategic Partners for Growth</h3>
            <p className="text-lg text-gray-700 mb-6">
              Founded by industry veterans with decades of combined experience in venture capital and startup financing, EquiCore Nexus provides the financial expertise to navigate complex markets and maximize opportunities.
            </p>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-start">
                <div className="text-[#3B82F6] mt-1 mr-3">
                  <i className="fas fa-check-circle"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#0F172A]">Comprehensive Financial Strategy</h4>
                  <p className="text-gray-600">End-to-end financial planning from seed to exit</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="text-[#3B82F6] mt-1 mr-3">
                  <i className="fas fa-check-circle"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#0F172A]">Venture Capital Expertise</h4>
                  <p className="text-gray-600">Deep understanding of VC expectations and processes</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="text-[#3B82F6] mt-1 mr-3">
                  <i className="fas fa-check-circle"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#0F172A]">Data-Driven Approach</h4>
                  <p className="text-gray-600">Market intelligence and benchmarking for optimal outcomes</p>
                </div>
              </div>
            </div>
            
            <a href="#services" className="inline-flex items-center text-[#3435cf] font-semibold hover:text-blue-700 transition">
              Explore our expertise
              <i className="fas fa-arrow-right ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;